module.exports = __webpack_public_path__ + "img/operatorIcon.4d4d34b1.svg";